import { InjectionToken } from '@angular/core';

export const BACKEND_HOST = new InjectionToken<string>('Backend Host');
